/* istanbul ignore file */

import styled, { css } from 'styled-components';

import { colors, medias } from 'assets/styled/tokens';

export const StyledFiltersContainer = styled.div`
  width: 100%;
  display: flex !important;
  flex-flow: row wrap;
  align-items: center;
  justify-content: flex-start;
  font-weight: 500;
  gap: 10px;
  font-size: 12px;
  color: ${colors.gray};

  button {
    text-transform: uppercase;
  }

  ${props =>
    !props.isOpen &&
    css`
      ${StyledFilterColumn} {
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;

        @media screen and (max-width: ${medias.tablet}) {
          display: contents;
        }
      }
    `}
`;

export const StyledFilterColumn = styled.div`
  flex: 0 0 auto;
  padding: 0 1rem;
  display: block;
  margin: 5px;

  @media (max-width: ${medias.tablet}) {
    padding: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex: 1;
  }

  div {
    label {
      margin: 0px 5px 20px 5px !important;
      @media (max-width: ${medias.tablet}) {
        display: none;
      }
    }
  }

  @media (max-width: ${medias.tablet}) {
    flex: 1;
    width: 100%;
    padding: 0px;
    display: flex;
  }
`;
